document.addEventListener('DOMContentLoaded', function () {
    function initObserver() {
        const elements = document.querySelectorAll('.float-text');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );
        elements.forEach((el) => observer.observe(el));
    }
    function initVideoModal() {
        const btn = document.querySelector('.watch-video-btn');
        const modal = document.querySelector('.video-modal-overlay');
        const closeBtn = document.querySelector('.video-close-btn');
        const video = modal ? modal.querySelector('video') : null;

        if (btn && modal && video) {
            function updateVideoSource() {
                const isMobile = window.innerWidth <= 850;
                const targetSrc = isMobile ? video.getAttribute('data-mob-src') : video.getAttribute('data-pc-src');
                
                if (targetSrc) {
                    const currentSrc = video.src || '';
                    if (!currentSrc.includes(targetSrc)) {
                        const isPlaying = !video.paused;
                        video.src = targetSrc;
                        video.load();
                        if (isPlaying) {
                            video.play();
                        }
                    }
                }
            }

            btn.addEventListener('click', () => {
                modal.classList.add('active');
                modal.setAttribute('aria-hidden', 'false');
                updateVideoSource();
                video.play();
                closeBtn.focus();
            });
            closeBtn.addEventListener('click', () => {
                modal.classList.remove('active');
                modal.setAttribute('aria-hidden', 'true');
                video.pause();
                btn.focus();
            });
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.classList.remove('active');
                    modal.setAttribute('aria-hidden', 'true');
                    video.pause();
                    btn.focus();
                }
            });
            // ESC to close
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape' && modal.classList.contains('active')) {
                    modal.classList.remove('active');
                    modal.setAttribute('aria-hidden', 'true');
                    video.pause();
                    btn.focus();
                }
            });
            // Listen to window size changes
            window.addEventListener('resize', () => {
                if (modal.classList.contains('active')) {
                    updateVideoSource();
                }
            });
        }
    }

    function initTangleCutCarousel() {
        const swiperEl = document.querySelector('.tanglecut-carousel-pc');
        const tabNamesAttr = swiperEl ? swiperEl.getAttribute('data-tab-names') : '';
        const tabNames = tabNamesAttr ? tabNamesAttr.split(',').filter(Boolean) : ['TangleCut™ Multi-Surface Brush', 'See the Difference'];

        // PC Swiper
        new Swiper('.tanglecut-carousel-pc', {
            slidesPerView: 1,
            spaceBetween: 20,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: false,
            pagination: {
                el: '.tanglecut-pagination-pc',
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}">${tabNames[index] || ''}</span>`;
                },
            },
        });

        // Mobile Swiper
        new Swiper('.tanglecut-carousel-mob', {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.tanglecut-next-mob',
                prevEl: '.tanglecut-prev-mob',
            },
        });
    }

    function initCelestectCarousel() {
        const swiperEl = document.querySelector('.celestect-carousel-pc');
        const tabNamesAttr = swiperEl ? swiperEl.getAttribute('data-tab-names') : '';
        const tabNames = tabNamesAttr ? tabNamesAttr.split(',').filter(Boolean) : ['CelesTect™ Illumination', 'Adapts to Multiple Floor Types'];

        // PC Swiper
        new Swiper('.celestect-carousel-pc', {
            slidesPerView: 1,
            spaceBetween: 20,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: false,
            pagination: {
                el: '.celestect-pagination-pc',
                type: 'bullets',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="${className}">${tabNames[index] || ''}</span>`;
                },
            },
        });

        // Mobile Swiper
        new Swiper('.celestect-carousel-mob', {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.celestect-next-mob',
                prevEl: '.celestect-prev-mob',
            },
        });
    }

    function initToolsCarousel() {
        function getSpaceBetween() {
            const width = window.innerWidth;
            if (width >= 850 && width <= 1500) {
                return 32 * (width / 2560);
            }
            return 32;
        }
        // PC Swiper
        new Swiper('.tools-carousel-pc', {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: getSpaceBetween(),
            navigation: {
                nextEl: '.tools-next-pc',
                prevEl: '.tools-prev-pc',
            },
            on: {
                slideChangeTransitionEnd: function () {
                    this.update();
                }
            }
        });

        // Mobile Swiper
        new Swiper('.tools-carousel-mob', {
            slidesPerView: 'auto',
            spaceBetween: 16,
            navigation: {
                nextEl: '.tools-next-mob',
                prevEl: '.tools-prev-mob',
            },
        });
    }

    function initSensingCarousel() {
        // PC Swiper
        new Swiper('.sensing-carousel-pc', {
            slidesPerView: 1,
            spaceBetween: 20,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: false,
            navigation: {
                nextEl: '.sensing-next-pc',
                prevEl: '.sensing-prev-pc',
            },
        });

        // Mobile Swiper
        new Swiper('.sensing-carousel-mob', {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.sensing-next-mob',
                prevEl: '.sensing-prev-mob',
            },
        });
    }

    initObserver();
    initVideoModal();
    initTangleCutCarousel();
    initCelestectCarousel();
    initToolsCarousel();
    initSensingCarousel();
});
